import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3 row justify-content-center" }
const _hoisted_2 = {
  style: {"height":"400px","width":"100%"},
  class: "position-relative"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "no-screen" }
const _hoisted_5 = {
  class: "table",
  cellpadding: 5
}
const _hoisted_6 = { class: "list-tickets" }
const _hoisted_7 = { style: {"width":"60% !important","text-align":"left"} }

import Api from '@/services/api';
    import { Event, Ticket } from '@/services/types';
    import { ElTag, ElDialog, ElDatePicker, ElMessage, ElRow, FormInstance, FormRules, ElCol, ElInputNumber, ElInput, ElDivider, ElFormItem, ElDescriptions, ElDescriptionsItem } from 'element-plus';
    import { onBeforeMount, reactive, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip} from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'
    import { toFormData } from '@/utilities/helpers';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EventView',
  setup(__props) {

    const route = useRoute()
    const id = route.params.id

    const loading = ref<boolean>(true)
    const saving = ref<boolean>(false)
    const locating = ref<boolean>(false)
    const showTickets = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const image = ref<File | null>(null)
    const apiImage = ref<string>()

    const event = reactive<Event>({
        type: '',
        description: '',
        event_time: new Date(),
        image: null,
        name: '',
        places: 0,
        price: 0,
        vip_price: 0,
        vips: 0,
        remaining_places: 0,
        remaining_vips: 0,
        area: {lat: 0, long: 0, name: ''}
    })

    const getImageUrl = (image: string) => `${Api.publicUrl}alt-storage?path=events/${image}`
    const tickets = ref<Array<Ticket>>([])

    const rules = ref<FormRules<Event>>({
        name: [{required: true, message: 'Preencha este campo'}],
        "area.name": [{required: true, message: 'Preencha este campo'}],
    })

    const openTickets = () => {
        showTickets.value = true
    }

    const changeFile = ({target: {files}}: any) => {
        console.log(files)
        if (files[0]) {
            image.value = files[0]
            event.image = URL.createObjectURL(files[0])
        } else {
            image.value = null
            event.image = (apiImage.value as string)
        }
    }

    const print = () => window.print()
    const getEvent = async (id: number | string) => {
        const res = await Api.get(`admin/events/${id}`)

        if (res.status == 200) {
            const data = res.data.event
    
            event.id = data.id
            event.area = data.area
            event.type = data.type
            event.remaining_places = data.remaining_places
            event.remaining_vips = data.remaining_vips
            event.user = data.user
            event.vips = data.vips
            event.vip_price = data.vip_price
            event.type = data.type
            event.price = data.price
            event.places = data.places
            event.name = data.name
            event.description = data.description
            event.event_time = data.event_time
            event.created_at = data.created_at

            apiImage.value = getImageUrl(data.image)
            event.image = apiImage.value
            console.log(data)
        } else {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
    }
    
    const getTickets = async (id: number | string) => {
        const res = await Api.get(`admin/events/tickets/${id}`)
        if (res.status == 200) {
            tickets.value = res.data.tickets
        } else {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
    }

    const onMapClick = (mouseEvent: LeafletMouseEvent) => {
        const { lat, lng } = mouseEvent.latlng
        if (event.area) {
            event.area.lat = lat
            event.area.long = lng
        } else {
            event.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(event.area);
    }

    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (event.area) {
                event.area.lat = position.coords.latitude
                event.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!event.area?.lat || !event.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const formData = toFormData(event)
                if (image.value) {
                    formData.append("image", image.value)
                } else {
                    formData.delete("image")
                }
                const res = await Api.post('/admin/events/' + event.id, event, formData)
                if (res.status == 200) {
                    await getEvent(id as string)
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

    onBeforeMount(async () => {
        loading.value = true
        await Promise.all([
            getEvent(id as string),
            getTickets(id as string),
        ])
        loading.value = false
    })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_ElText = _resolveComponent("ElText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "col-12 print-sheet",
      header: event.id ? event.name:'Procurando Evento'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_skeleton, {
          loading: loading.value,
          animated: "",
          rows: 12,
          class: "no-print"
        }, {
          default: _withCtx(() => [
            event
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 0,
                  disabled: saving.value,
                  model: event,
                  "label-position": "top",
                  rules: rules.value,
                  ref_key: "formRef",
                  ref: formRef,
                  class: "no-print"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElRow), { gutter: 30 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElCol), {
                          sm: 24,
                          md: 12,
                          lg: 10
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElFormItem), {
                              label: "Nome do evento",
                              prop: "name"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  name: "name",
                                  modelValue: event.name,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((event.name) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElFormItem), {
                              label: "Tipo do evento",
                              prop: "type"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  name: "type",
                                  modelValue: event.type,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((event.type) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElFormItem), {
                              label: "Data e hora",
                              prop: "event_time"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElDatePicker), {
                                  type: "datetime",
                                  format: "DD/MM/YYYY HH:mm:ss",
                                  "value-format": "YYYY-MM-DD HH:mm:ss",
                                  name: "event_time",
                                  clearable: false,
                                  modelValue: event.event_time,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((event.event_time) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElFormItem), {
                              label: "Descricao do evento",
                              prop: "description"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  type: "textarea",
                                  name: "description",
                                  modelValue: event.description,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((event.description) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElRow), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElCol), {
                                  sm: 12,
                                  md: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElFormItem), {
                                      label: "Preço normal",
                                      prop: "price"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ElInputNumber), {
                                          name: "price",
                                          modelValue: event.price,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((event.price) = $event)),
                                          step: 0.001,
                                          min: 0
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(ElCol), {
                                  sm: 12,
                                  md: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElFormItem), {
                                      label: "Preço VIP",
                                      prop: "vip_price"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ElInputNumber), {
                                          name: "vip_price",
                                          modelValue: event.vip_price,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((event.vip_price) = $event)),
                                          step: 0.001,
                                          min: 0
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElRow), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElCol), {
                                  sm: 12,
                                  md: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElFormItem), {
                                      label: "Nr de lugares normais",
                                      prop: "places"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ElInputNumber), {
                                          name: "places",
                                          modelValue: event.places,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((event.places) = $event)),
                                          step: 1,
                                          min: 0
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(ElCol), {
                                  sm: 12,
                                  md: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElFormItem), {
                                      label: "Nr de lugares VIP",
                                      prop: "vips"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ElInputNumber), {
                                          name: "vips",
                                          modelValue: event.vips,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((event.vips) = $event)),
                                          step: 1,
                                          min: 0
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElDivider)),
                            _createVNode(_unref(ElRow), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElCol), {
                                  sm: 12,
                                  md: 12,
                                  class: "text-warning"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("strong", null, _toDisplayString(event.remaining_places), 1),
                                    _cache[11] || (_cache[11] = _createTextVNode()),
                                    _cache[12] || (_cache[12] = _createElementVNode("label", null, " Lugares restantes", -1))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(ElCol), {
                                  sm: 12,
                                  md: 12,
                                  class: "text-success"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("strong", null, _toDisplayString(event.remaining_vips), 1),
                                    _cache[13] || (_cache[13] = _createTextVNode()),
                                    _cache[14] || (_cache[14] = _createElementVNode("label", null, " Lugares VIP restantes", -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElDivider)),
                            _createVNode(_unref(ElFormItem), { label: "Cadastrado" }, {
                              default: _withCtx(() => [
                                _cache[15] || (_cache[15] = _createTextVNode(" Por ", -1)),
                                _createElementVNode("b", null, _toDisplayString(event.user?.name), 1),
                                _cache[16] || (_cache[16] = _createTextVNode(", em ", -1)),
                                _createElementVNode("b", null, _toDisplayString(event.created_at ? new Date(event.created_at).toLocaleString():'-'), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(ElCol), {
                          sm: 24,
                          md: 12,
                          lg: 14
                        }, {
                          default: _withCtx(() => [
                            (event.area)
                              ? (_openBlock(), _createBlock(_unref(ElFormItem), {
                                  key: 0,
                                  label: "Local",
                                  prop: "area.name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElInput), {
                                      name: "area",
                                      modelValue: event.area.name,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((event.area.name) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_2, [
                              _createVNode(_component_el_button, {
                                plain: "",
                                class: "position-absolute end-0",
                                style: {"z-index":"1024"},
                                loading: locating.value || loading.value,
                                size: "large",
                                type: "success",
                                onClick: _withModifiers(locate, ["prevent"])
                              }, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                  _createTextVNode(" Localizar-me ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["loading"]),
                              (event.area)
                                ? (_openBlock(), _createBlock(_unref(LMap), {
                                    key: 0,
                                    onContextmenu: onMapClick,
                                    ref: "map",
                                    zoom: 16,
                                    center: [event.area.lat, event.area.long]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(LTileLayer), {
                                        url: "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga",
                                        "layer-type": "base",
                                        name: "OpenStreetMap"
                                      }),
                                      (event.area)
                                        ? (_openBlock(), _createBlock(_unref(LMarker), {
                                            key: 0,
                                            "lat-lng": [event.area.lat, event.area.long]
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(LTooltip), null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(event.name), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["lat-lng"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["center"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_unref(ElFormItem), {
                              label: "Imagem promocional",
                              prop: "image"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  style: {"max-height":"250px","max-width":"100%"},
                                  src: (event.image as string)
                                }, null, 8, _hoisted_3),
                                _createElementVNode("input", {
                                  type: "file",
                                  name: "image",
                                  onChange: changeFile
                                }, null, 32)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "model", "rules"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(ElRow), {
              justify: "space-between",
              class: "py-4 no-print"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElCol), { class: "col-auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "warning",
                      onClick: openTickets,
                      plain: "",
                      loading: saving.value
                    }, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode(" Bilhetes comprados ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_el_button, {
                      type: "success",
                      onClick: print,
                      plain: "",
                      loading: saving.value
                    }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode(" Imprimir lista ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElCol), { class: "col-auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (submit(formRef.value))),
                      plain: "",
                      loading: saving.value
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode(" Salvar alterações ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(ElDescriptions), {
            class: "margin-top",
            title: "Detalhes do eventos",
            column: 3,
            size: 'default',
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElDescriptionsItem), null, {
                label: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("div", { class: "cell-item" }, " Nome do evento ", -1)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(event.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ElDescriptionsItem), null, {
                label: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createElementVNode("div", { class: "cell-item" }, " Local ", -1)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(event.area.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ElDescriptionsItem), null, {
                label: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("div", { class: "cell-item" }, " Data e hora ", -1)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(new Date(event.event_time).toLocaleString('af')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ElDescriptionsItem), null, {
                label: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("div", { class: "cell-item" }, " Preç0 Normal ", -1)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(event.price) + " MT ", 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ElDescriptionsItem), null, {
                label: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("div", { class: "cell-item" }, " Preço VIP ", -1)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(event.vip_price), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _cache[27] || (_cache[27] = _createElementVNode("h5", { class: "pt-4" }, "Bilhetes", -1)),
          _createElementVNode("table", _hoisted_5, [
            _cache[26] || (_cache[26] = _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Cod"),
              _createElementVNode("th", null, "Nome"),
              _createElementVNode("th", null, "idade"),
              _createElementVNode("th", null, "BI"),
              _createElementVNode("th", null, "VIP?")
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tickets.value, (ticket) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: ticket.id
              }, [
                _createElementVNode("td", null, _toDisplayString(ticket.id), 1),
                _createElementVNode("td", null, _toDisplayString(ticket.name), 1),
                _createElementVNode("td", null, _toDisplayString(ticket.old), 1),
                _createElementVNode("td", null, _toDisplayString(ticket.id_number), 1),
                _createElementVNode("td", null, _toDisplayString(ticket.vip ? 'VIP':'NORMAL'), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["header"]),
    _createVNode(_unref(ElDialog), {
      "align-center": "",
      center: "",
      "show-close": "",
      title: 'Lista Bilhetes comprados',
      class: "no-print",
      modelValue: showTickets.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showTickets).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tickets.value, (ticket) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: ticket.id
            }, [
              _createElementVNode("td", null, [
                _createVNode(_unref(ElTag), {
                  size: "small",
                  type: ticket.vip ? 'success':'info'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(ticket.vip ? 'VIP':'Normal'), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _createElementVNode("td", _hoisted_7, "| " + _toDisplayString(ticket.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_ElText, {
                  type: "success",
                  style: {"text-align":"right"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(ticket.price) + " MT", 1)
                  ]),
                  _: 2
                }, 1024),
                _cache[28] || (_cache[28] = _createTextVNode("  ", -1))
              ]),
              _createElementVNode("td", null, [
                _createVNode(_unref(ElTag), {
                  size: "small",
                  type: ticket.used_at ? 'danger':'success'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(ticket.used_at ? 'Usado':'Valido'), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})